// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile_pg_wrapper {
  width: 100%;
  min-height: 100vh;
  background: #f6f3ec;
  box-sizing: border-box;
  font-family: 'Manrope', sans-serif;
  padding: 48px 24px 72px;
}

/* ---------- HEADER CARD ---------- */

.profile_pg_header_card {
  max-width: 720px;
  margin: 0 auto 40px;
  background: #241f16;
  border-radius: 20px;
  padding: 30px 28px;
  display: flex;
  align-items: center;
  gap: 20px;
  box-shadow: 0 10px 30px rgba(28, 27, 20, 0.14);
  animation: profile_pg_fadeIn 0.5s ease both;
}

@keyframes profile_pg_fadeIn {
  from { opacity: 0; transform: translateY(16px); }
  to { opacity: 1; transform: translateY(0); }
}

.profile_pg_avatar {
  flex-shrink: 0;
  width: 66px;
  height: 66px;
  border-radius: 50%;
  background: #ff8a5c;
  color: #241f16;
  font-size: 22px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
}

.profile_pg_header_info {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.profile_pg_name {
  font-size: 19px;
  font-weight: 800;
  color: #ffffff;
  margin: 0;
  letter-spacing: -0.2px;
}

.profile_pg_email,
.profile_pg_phone {
  font-size: 13px;
  font-weight: 500;
  color: #c9c3b6;
  margin: 0;
}

/* ---------- SECTION HEAD ---------- */

.profile_pg_section_head {
  max-width: 720px;
  margin: 0 auto 24px;
  text-align: center;
}

.profile_pg_section_title {
  font-size: 20px;
  font-weight: 800;
  color: #241f16;
  margin: 0 0 6px;
}

.profile_pg_section_sub {
  font-size: 13px;
  font-weight: 500;
  color: #8a8478;
  margin: 0;
}

.profile_pg_loading {
  text-align: center;
  font-size: 13.5px;
  font-weight: 600;
  color: #8a8478;
}

/* ---------- MODULE GRID ---------- */

.profile_pg_grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
  max-width: 1080px;
  margin: 0 auto;
}

.profile_pg_card {
  position: relative;
  background: #ffffff;
  border-radius: 16px;
  padding: 20px 20px 22px;
  box-shadow: 0 4px 14px rgba(28, 27, 20, 0.06);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  animation: profile_pg_popIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

.profile_pg_grid .profile_pg_card:nth-child(1) { animation-delay: 0.05s; }
.profile_pg_grid .profile_pg_card:nth-child(2) { animation-delay: 0.11s; }
.profile_pg_grid .profile_pg_card:nth-child(3) { animation-delay: 0.17s; }
.profile_pg_grid .profile_pg_card:nth-child(4) { animation-delay: 0.23s; }
.profile_pg_grid .profile_pg_card:nth-child(5) { animation-delay: 0.29s; }

@keyframes profile_pg_popIn {
  from { opacity: 0; transform: scale(0.94) translateY(14px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}

.profile_pg_card:not(.profile_pg_card_locked):hover {
  transform: translateY(-4px);
  box-shadow: 0 14px 28px rgba(28, 27, 20, 0.12);
}

.profile_pg_card_locked {
  filter: blur(1.5px) grayscale(30%);
  opacity: 0.65;
}

.profile_pg_card_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
}

.profile_pg_card_num {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.4px;
  color: #ff8a5c;
  text-transform: uppercase;
}

.profile_pg_lock_badge {
  font-size: 10.5px;
  font-weight: 800;
  letter-spacing: 0.3px;
  color: #ffffff;
  background: #241f16;
  padding: 4px 10px;
  border-radius: 100px;
}

.profile_pg_done_badge {
  font-size: 10.5px;
  font-weight: 800;
  letter-spacing: 0.3px;
  color: #ffffff;
  background: #34c795;
  padding: 4px 10px;
  border-radius: 100px;
}

.profile_pg_card_title {
  font-size: 14.5px;
  font-weight: 800;
  color: #241f16;
  margin: 0 0 14px;
  line-height: 1.4;
}

.profile_pg_progress_track {
  width: 100%;
  height: 7px;
  border-radius: 100px;
  background: #f0ede4;
  overflow: hidden;
  margin-bottom: 8px;
}

.profile_pg_progress_fill {
  height: 100%;
  border-radius: 100px;
  background: linear-gradient(90deg, #ff8a5c, #34c795);
  transition: width 0.5s ease;
}

.profile_pg_progress_text {
  font-size: 12px;
  font-weight: 700;
  color: #4b5165;
}

.profile_pg_locked_text {
  font-size: 12px;
  font-weight: 500;
  color: #8a8478;
  line-height: 1.5;
  margin: 0;
}

/* ---------- RESPONSIVE ---------- */

@media (max-width: 640px) {
  .profile_pg_wrapper {
    padding: 36px 18px 56px;
  }

  .profile_pg_header_card {
    flex-direction: column;
    text-align: center;
    padding: 26px 22px;
  }

  .profile_pg_grid {
    grid-template-columns: 1fr;
    max-width: 420px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .profile_pg_header_card,
  .profile_pg_card {
    animation: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Auth/ProfilePage/ProfilePage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA,sCAAsC;;AAEtC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8CAA8C;EAC9C,2CAA2C;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,uCAAuC;;AAEvC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,sCAAsC;;AAEtC;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,qDAAqD;EACrD,uEAAuE;AACzE;;AAEA,iDAAiD,sBAAsB,EAAE;AACzE,iDAAiD,sBAAsB,EAAE;AACzE,iDAAiD,sBAAsB,EAAE;AACzE,iDAAiD,sBAAsB,EAAE;AACzE,iDAAiD,sBAAsB,EAAE;;AAEzE;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA,qCAAqC;;AAErC;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF","sourcesContent":[".profile_pg_wrapper {\n  width: 100%;\n  min-height: 100vh;\n  background: #f6f3ec;\n  box-sizing: border-box;\n  font-family: 'Manrope', sans-serif;\n  padding: 48px 24px 72px;\n}\n\n/* ---------- HEADER CARD ---------- */\n\n.profile_pg_header_card {\n  max-width: 720px;\n  margin: 0 auto 40px;\n  background: #241f16;\n  border-radius: 20px;\n  padding: 30px 28px;\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  box-shadow: 0 10px 30px rgba(28, 27, 20, 0.14);\n  animation: profile_pg_fadeIn 0.5s ease both;\n}\n\n@keyframes profile_pg_fadeIn {\n  from { opacity: 0; transform: translateY(16px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.profile_pg_avatar {\n  flex-shrink: 0;\n  width: 66px;\n  height: 66px;\n  border-radius: 50%;\n  background: #ff8a5c;\n  color: #241f16;\n  font-size: 22px;\n  font-weight: 800;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.profile_pg_header_info {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.profile_pg_name {\n  font-size: 19px;\n  font-weight: 800;\n  color: #ffffff;\n  margin: 0;\n  letter-spacing: -0.2px;\n}\n\n.profile_pg_email,\n.profile_pg_phone {\n  font-size: 13px;\n  font-weight: 500;\n  color: #c9c3b6;\n  margin: 0;\n}\n\n/* ---------- SECTION HEAD ---------- */\n\n.profile_pg_section_head {\n  max-width: 720px;\n  margin: 0 auto 24px;\n  text-align: center;\n}\n\n.profile_pg_section_title {\n  font-size: 20px;\n  font-weight: 800;\n  color: #241f16;\n  margin: 0 0 6px;\n}\n\n.profile_pg_section_sub {\n  font-size: 13px;\n  font-weight: 500;\n  color: #8a8478;\n  margin: 0;\n}\n\n.profile_pg_loading {\n  text-align: center;\n  font-size: 13.5px;\n  font-weight: 600;\n  color: #8a8478;\n}\n\n/* ---------- MODULE GRID ---------- */\n\n.profile_pg_grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 20px;\n  max-width: 1080px;\n  margin: 0 auto;\n}\n\n.profile_pg_card {\n  position: relative;\n  background: #ffffff;\n  border-radius: 16px;\n  padding: 20px 20px 22px;\n  box-shadow: 0 4px 14px rgba(28, 27, 20, 0.06);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  animation: profile_pg_popIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) both;\n}\n\n.profile_pg_grid .profile_pg_card:nth-child(1) { animation-delay: 0.05s; }\n.profile_pg_grid .profile_pg_card:nth-child(2) { animation-delay: 0.11s; }\n.profile_pg_grid .profile_pg_card:nth-child(3) { animation-delay: 0.17s; }\n.profile_pg_grid .profile_pg_card:nth-child(4) { animation-delay: 0.23s; }\n.profile_pg_grid .profile_pg_card:nth-child(5) { animation-delay: 0.29s; }\n\n@keyframes profile_pg_popIn {\n  from { opacity: 0; transform: scale(0.94) translateY(14px); }\n  to { opacity: 1; transform: scale(1) translateY(0); }\n}\n\n.profile_pg_card:not(.profile_pg_card_locked):hover {\n  transform: translateY(-4px);\n  box-shadow: 0 14px 28px rgba(28, 27, 20, 0.12);\n}\n\n.profile_pg_card_locked {\n  filter: blur(1.5px) grayscale(30%);\n  opacity: 0.65;\n}\n\n.profile_pg_card_top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.profile_pg_card_num {\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.4px;\n  color: #ff8a5c;\n  text-transform: uppercase;\n}\n\n.profile_pg_lock_badge {\n  font-size: 10.5px;\n  font-weight: 800;\n  letter-spacing: 0.3px;\n  color: #ffffff;\n  background: #241f16;\n  padding: 4px 10px;\n  border-radius: 100px;\n}\n\n.profile_pg_done_badge {\n  font-size: 10.5px;\n  font-weight: 800;\n  letter-spacing: 0.3px;\n  color: #ffffff;\n  background: #34c795;\n  padding: 4px 10px;\n  border-radius: 100px;\n}\n\n.profile_pg_card_title {\n  font-size: 14.5px;\n  font-weight: 800;\n  color: #241f16;\n  margin: 0 0 14px;\n  line-height: 1.4;\n}\n\n.profile_pg_progress_track {\n  width: 100%;\n  height: 7px;\n  border-radius: 100px;\n  background: #f0ede4;\n  overflow: hidden;\n  margin-bottom: 8px;\n}\n\n.profile_pg_progress_fill {\n  height: 100%;\n  border-radius: 100px;\n  background: linear-gradient(90deg, #ff8a5c, #34c795);\n  transition: width 0.5s ease;\n}\n\n.profile_pg_progress_text {\n  font-size: 12px;\n  font-weight: 700;\n  color: #4b5165;\n}\n\n.profile_pg_locked_text {\n  font-size: 12px;\n  font-weight: 500;\n  color: #8a8478;\n  line-height: 1.5;\n  margin: 0;\n}\n\n/* ---------- RESPONSIVE ---------- */\n\n@media (max-width: 640px) {\n  .profile_pg_wrapper {\n    padding: 36px 18px 56px;\n  }\n\n  .profile_pg_header_card {\n    flex-direction: column;\n    text-align: center;\n    padding: 26px 22px;\n  }\n\n  .profile_pg_grid {\n    grid-template-columns: 1fr;\n    max-width: 420px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .profile_pg_header_card,\n  .profile_pg_card {\n    animation: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
